var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.component,{tag:"component",attrs:{"disabled":_vm.disabled,"title":_vm.title},on:{"navigation:click":function($event){return _vm.$emit('navigation:click')}}})}
var staticRenderFns = []

export { render, staticRenderFns }